import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../../../constants/actionTypes';
import Drawer from '../../../Common/Drawer/Drawer';
import Notification from '../../../Common/Notification';
import AllLocationsForm from './AllLocationsForms';
import LocationAttributesForm from './LocationAttributesForm';
import LocationNameForm from './LocationNameForm';
import './AddToScopeDrawer.scss';
import { Menu } from 'primereact/menu';

const FORMS = {
    AllLocations: {
        Id: 'AllLocations',
        Name: 'All Locations',
        Message: 'Add all locations to scope'
    },
    LocationName: {
        Id: 'LocationName',
        Name: 'Customize by Location Name',
        Message: 'Add all locations listed below to scope'
    },
    LocationAttributes: {
        Id: 'LocationAttributes',
        Name: 'Customize by Location Attributes',
        Message: 'Add all locations listed below to scope'
    }
}

export default class AddToScopeDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedLocations: [],
            isFormValid: true,
            isLoading: false,
            currentForm: FORMS.LocationName.Id
        };
    }

    componentDidMount = () => {
        if (this.props.openAttributeForm === true) {
            this.setState({ currentForm: FORMS.LocationAttributes.Id })
        }
    }

    addToScope = async () => {
        try {
            this.setState({ isLoading: true });
            var request = {
                subscriptionId: this.props.subscriptionId,
                projectKey: this.props.projectKey,
                locationIds: this.state.selectedLocations.map(x => x.id)
            }
            const response = await this.props.projectLocationActions.addToScope(request);
            if (response.type === types.ADD_TO_PROJECTLOCATION_SCOPE_SUCCESS) {
                Notification("success", "Success", "Add To Scope completed successfully");
                this.props.onComplete();
            } else if (response.type === types.ADD_TO_PROJECTLOCATION_SCOPE_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        }
    }

    setSelectedLocations = (newLocations) => {
        this.setState({ selectedLocations: newLocations });
    }

    renderForm() {
        /**
         * LoadingIndicator was removed from this component, because it no-longer loads
         * anything on mount, and if the entire sub-form was umounted via a loading indicator
         * being triggered on AddToScope, it would lose all of its local state.  As such, we
         * just pass in the isLoading prop so that each sub-form can indicate via its
         * LoadingIndicator that a save attempt is in process.  If that save attempt fails,
         * the sub-form does not lose its local state and keeps the users search params
         * where they are on the open drawer.
         */
        switch (this.state.currentForm) {
            case FORMS.AllLocations.Id: {
                return <AllLocationsForm
                    subscriptionId={this.props.subscriptionId}
                    projectKey={this.props.projectKey}
                    projectLocationActions={this.props.projectLocationActions}
                    setSelectedLocations={this.setSelectedLocations}
                    isLoading={this.state.isLoading}
                />;
            }
            case FORMS.LocationName.Id: {
                return <LocationNameForm
                    subscriptionId={this.props.subscriptionId}
                    projectKey={this.props.projectKey}
                    selectedLocations={this.state.selectedLocations}
                    projectLocationActions={this.props.projectLocationActions}
                    setSelectedLocations={this.setSelectedLocations}
                    isLoading={this.state.isLoading}
                />;
            }
            case FORMS.LocationAttributes.Id: {
                return <LocationAttributesForm
                    subscriptionId={this.props.subscriptionId}
                    projectKey={this.props.projectKey}
                    selectedLocations={this.state.selectedLocations}
                    projectLocationActions={this.props.projectLocationActions}
                    setSelectedLocations={this.setSelectedLocations}
                    isLoading={this.state.isLoading}
                />;
            }
            default: {
                Notification("error", "Error", "Unknown Form Selected");
                return null;
            }
        }
    }

    menuOptionClick = (e) => {
        this.setState({ currentForm: e.item.value, selectedLocations: [] });
    }

    onCustomizeClick = (e) => {
        this.menu.toggle(e);
    }

    render() {
        const customFooter = <div className="button-wrap text-end">
            <span>Add {this.state.selectedLocations.length} locations to scope</span>
            <button type="button" className="btn btn-primary button--save" onClick={this.addToScope}>Add to Scope</button>
            <button type="button" className="btn btn-secondary" onClick={this.props.onCancel}>Cancel</button>
        </div>

        const menuOptions = [
            /*{ label: FORMS.AllLocations.Name, value: FORMS.AllLocations.Id, command: this.menuOptionClick },*/
            { label: FORMS.LocationName.Name, value: FORMS.LocationName.Id, command: this.menuOptionClick },
            { label: FORMS.LocationAttributes.Name, value: FORMS.LocationAttributes.Id, command: this.menuOptionClick }
        ];

        /**
         * Do not include the current form menu item in the context menu that shows 
         * when clicking the customize link
         * 
         */
        let customizeMenuOptions = menuOptions.filter(x => x.value !== this.state.currentForm);

        return (
            <div className="add-to-scope-drawer">
                <Menu model={customizeMenuOptions} popup={true} ref={el => this.menu = el} />
                <Drawer isWide={true}
                    title='Add Locations to Scope'
                    onCancelClick={this.props.onCancel}
                    customFooter={customFooter}
                >
                    <div className="drawer-message">
                        {FORMS[this.state.currentForm].Message}
                        <button type="button" className="btn btn-link" onClick={this.onCustomizeClick}>Customize</button>
                    </div>
                    {this.renderForm()}
                </Drawer>
            </div>
        )
    }
}

AddToScopeDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    projectLocationActions: PropTypes.object.isRequired,
    openAttributeForm: PropTypes.bool
};
